import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import TimeChart from './TimeChart';
import TimeTotals from './TimeTotals';
import {BudgetDataWrapper, TimeChartWrapper} from '../BudgetData.styled';
import HighLevelTimeNumbers from '../HighLevelTimeNumbers';
import {hasFeatureFlag} from '../../../../../forecast-app/shared/util/FeatureUtil';

const TimeBudgetData = ({project, selectedAggregateLevel, eyeOptionMap}) => {
	const hasFinancialCategoriesUpdate = hasFeatureFlag('financial_categories_update');

	return (
		<>
			<BudgetDataWrapper>
				<TimeChartWrapper>
					<TimeChart project={project} selectedAggregateLevel={selectedAggregateLevel} eyeOptionMap={eyeOptionMap} />
					{hasFinancialCategoriesUpdate && <HighLevelTimeNumbers key={'HighLevelTimeNumbers'} project={project} />}
				</TimeChartWrapper>
				<TimeTotals project={project} eyeOptionMap={eyeOptionMap} />
			</BudgetDataWrapper>
		</>
	);
};

export default createFragmentContainer(TimeBudgetData, {
	project: graphql`
		fragment TimeBudgetData_project on ProjectType {
			...TimeChart_project
			...TimeTotals_project
			...HighLevelTimeNumbers_project
		}
	`,
});
